document.addEventListener("alpine:init", () => {
    Alpine.data("caseStudyShare", () => ({
        isFixed: false,
        menuHeight: 89,
        isMobile: true,
        positionTop: 0,
        bar: null,
        shareDesktop: false,
        shareMobile: false,
        init() {
            this.bar = this.$refs.fixedBar;

            pegasus.onResizeFinished(() => {
                this.isMobile = window.outerWidth <= 992;
                setTimeout(() => {
                    this.positionTop = pegasus.getElemOffset(this.$refs.barTop);
                }, 200);
            }, true);
        },
        fix() {
            if (!this.isMobile) {
                if (this.isFixed) {
                    if (
                        window.scrollY <= this.menuHeight ||
                        window.scrollY >= this.positionTop.top
                    ) {
                        this.isFixed = false;
                    }
                } else {
                    if (
                        window.scrollY >= this.menuHeight &&
                        window.scrollY <= this.positionTop.top
                    ) {
                        this.isFixed = true;
                    }
                }
            }
        },
    }));
});

window.copyLink = () => {
    return {
        copied: false,
        copyToClipboard() {
            navigator.clipboard.writeText(this.$el.getAttribute("href")).then(
                () => {
                    this.copied = true;
                    setTimeout(() => (this.copied = false), 2000);
                },
                () => {
                    /* clipboard write failed */
                }
            );
        },
    };
};
